<!--  -->
<template>
  <div class="home">
    <!-- <van-nav-bar
      left-arrow
      fixed
      @click-left="$router.go(-1)"
      :style="{ background: sessionStorage.colorCode }"
    >
    </van-nav-bar>
    <div class="fail">{{ $t("OrderDetail.cashPay") }}</div> -->
    <van-nav-bar
      :style="{ background: sessionStorage.colorCode }"
      :title="$t('OrderDetail.title')"
      fixed
    >
    </van-nav-bar>
    <div class="detail_top" v-if="orderDetail">
      <div style="text-align: center; margin-top: 20px">
        <div
          class="price_icon"
          :style="{ background: sessionStorage.colorCode }"
        >
          <img src="static/img/placeOrder.png" alt="" />
        </div>
      </div>

      <div class="top_price" style="margin-top: 20px">
        {{ $t("OrderDetail.success") }}
      </div>
      <div
        class="top_price"
        style="font-size: 22px; color: #fd1211; margin-top: 20px;"
      >
        {{ $t("OrderDetail.orderNo") }}：{{ orderDetail.ticket }}
      </div>
      <div class="top_price" style="margin-top: 15px;">
        {{ $t("OrderDetail.cashPay") }}
        <span style="margin-left: 5px; font-size: 16px;">
          {{ sessionStorage.getItem("currency") }}
        </span>
        {{ orderDetail.final_price }}
      </div>
      <div class="orderNum">
        {{ $t("OrderDetail.orderNum") }}：{{ orderDetail.order }}
      </div>
      <div
        style="height: 2px; width: 100%; background-color: #cdcdcd; margin: 10px 0px;"
      ></div>
      <div style="text-align: center;">
        <van-button :color="sessionStorage.colorCode" round plain @click="back">
          <template #icon>
            <svg-icon
              iconClass="orderDetail"
              style="width: 25px; height: 25px;"
              class="icon"
              :style="{ color: '#fff' }"
            />
          </template>
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderDetail: {}
    };
  },
  mounted() {
    this.actOrderId = sessionStorage.getItem("actOrderId");
    this.getOrderDetail();
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    getOrderDetail() {
      // 获取
      this.$axios({
        method: "PUT",
        headers: {
          type: sessionStorage.type,
          code: sessionStorage.code,
          placeid: sessionStorage.placeId
        },
        url: this.$build + "/api/order/" + this.actOrderId + "/customerIndex"
      })
        .then(res => {
          if (res.data.status == 200) {
            console.log(res);
            this.orderDetail = res.data.data;
            this.orderDetail.package.forEach(item => {
              let arr = [];
              if (item.category == "m") {
                if (item.tags_name) {
                  console.log(item.tags_name);
                  if (item.tags_name[0] != "") {
                    item.tags_name.forEach(i => {
                      if (typeof i == "object") {
                        i.forEach(tag => {
                          arr.push(tag);
                        });
                      } else {
                        arr.push(i);
                      }
                    });
                  }
                }
                item.tags_name = arr;
              }
            });
            console.log(res.data.data.finish);
            console.log(this.orderDetail.status);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-button {
  padding: 10px 50px;
}
.home {
  width: 100%;
  height: 100vh;
  background-color: #bbbbbb;
  padding-top: 56px;
}
.fail {
  text-align: center;
  margin-top: 100px;
  line-height: 40px;
  font-size: 30px;
  color: #2f75f4;
  font-weight: bold;
  background: #fff;
}
.detail_top {
  width: 90%;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0px 0px 10px #979797;
  margin: 0 auto;
  padding: 5px 10px 15px;
}
.row1 {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
}
.top_price {
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  margin-top: 5px;
}
.top_success {
  width: auto;
  height: 40px;
  line-height: 40px;
  padding-right: 10px;
  display: flex;
  align-items: center;
}
.top_sit {
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  font-weight: 600;
  padding-left: 10px;
}
.price_icon {
  /* background: rgb(255, 127, 0); */
  text-align: center;
  width: 30px;
  height: 30px;
  padding: 10px;
  display: inline-block;
  border-radius: 50%;
  border: 3px solid #000;
  position: relative;
}
.price_icon img {
  width: 28px;
  height: 23px;
  position: absolute;
  left: 22%;
  top: 23%;
}
.orderNum {
  text-align: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/CashPayment.vue